module.exports = __webpack_public_path__ + "static/media/azentio.6085e3ae.png";